import { createContext, useContext, useState } from "react";

const ScheduleTypesContext = createContext();

const useScheduleTypes = () => useContext(ScheduleTypesContext);

export { ScheduleTypesContext, useScheduleTypes };